/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisualizationGestureAPI
 * @hideconstructor
 * @classdesc API class that is used to handle the visualization gestures
 */
define([], () => {
	class VisualizationGestureAPI {

		/**
		 * @function VisualizationGestureAPI#setLassoSelectState
		 * @description Setting the state of lasso mode
		 * @param {boolean} [state] - The final state of lasso mode for the Vis. True means
		 * switch on, false means switch off. When not provided, the current state is inverted.
		 */
		setLassoSelectState(/* state */) {}

		/**
		 * @function VisualizationGestureAPI#getLassoSelectState
		 * @description Return the state of the lasso mode
		 * @param {boolean} - True implies the lasso select is active
		 */
		getLassoSelectState() {}

		/**
		 * @function VisualizationGestureAPI#getLassoViewId
		 * @description Return the ID of the current lasso view
		 * @param {string} - ID of the current lasso view
		 */
		getLassoViewId() {}

	}

	return VisualizationGestureAPI;
});
